module.exports = __webpack_public_path__ + "img/r-cb6-000-2.0d7973bf.gif";